module.exports = __webpack_public_path__ + "img/lfcx1.891f239d.jpg";